import toast from "react-hot-toast";
import { createPortal } from "react-dom";
import { apiHandler } from "../api";
import { endpoint } from "../api/endpoint";

const DELETE_ENDPOINTS = {
  product: endpoint.DELETE_PRODUCT,
  model: endpoint.DELETE_MODEL,
  background: endpoint.DELETE_BACKGROUND,
};

export function resolvePlaygroundItemId(item) {
  return (
    item?.id ||
    item?._id ||
    item?.product_id ||
    item?.productId ||
    item?.iProductId ||
    item?.model_id ||
    item?.modelId ||
    item?.iModelId ||
    item?.ModelId ||
    item?.background_id ||
    item?.backgroundId ||
    item?.iBackgroundId ||
    item?.BackgroundId ||
    item?.uuid ||
    null
  );
}

export function getPlaygroundItemLabel(item) {
  return item?.title || item?.name || "this item";
}

export async function deletePlaygroundItem({ resource, itemId, token }) {
  const deletePath = DELETE_ENDPOINTS[resource];

  if (!deletePath) {
    throw new Error("Unsupported delete resource.");
  }

  if (!itemId) {
    throw new Error("Missing item id.");
  }

  return apiHandler({
    url: `${endpoint.API_BASE_URL}${deletePath}/${itemId}`,
    method: "DELETE",
    authToken: { token },
  });
}

export function showDeleteConfirmationToast({
  title,
  description,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onConfirm,
}) {
  toast.custom(
    (t) => createPortal(
      <div
        onClick={() => toast.remove(t.id)}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(15, 23, 42, 0.45)",
          backdropFilter: "blur(3px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          cursor: "default",
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "#ffffff",
            color: "#1A2030",
            border: "1px solid #E2E8F0",
            borderRadius: "5px",
            padding: "12px",
            boxShadow: "rgba(0, 0, 0, 0.25) 0px 25px 50px -12px",
            maxWidth: "400px",
            width: "90%",
            textAlign: "left",
            display: "flex",
            gap: "8px",
          }}
        >
          {/* Warning Icon */}
          <div
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#FEE2E2",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#EF4444"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
              <line x1="12" y1="9" x2="12" y2="13" />
              <line x1="12" y1="17" x2="12.01" y2="17" />
            </svg>
          </div>

          {/* Content & Actions */}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px", flexGrow: 1 }}>
            <div>
              <h3 style={{ fontSize: "16px", fontWeight: 700, color: "#0F172A", margin: "0px", lineHeight: "24px" }}>
                {title}
              </h3>
              <p style={{ fontSize: "13.5px", lineHeight: "20px", color: "#64748B", margin: "6px 0px 0px" }}>
                {description}
              </p>
            </div>
            <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={() => toast.remove(t.id)}
                style={{
                  border: "1px solid #E2E8F0",
                  background: "#ffffff",
                  color: "#475569",
                  borderRadius: "8px",
                  padding: "1px 8px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  transition: "0.15s",
                  outline: "none",
                }}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                onClick={() => {
                  toast.remove(t.id);
                  onConfirm();
                }}
                style={{
                  border: "1px solid #ef4444",
                  background: "#ef4444",
                  color: "#ffffff",
                  borderRadius: "8px",
                  padding: "4px 7px",
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  transition: "0.15s",
                  outline: "none",
                  boxShadow: "rgba(239, 68, 68, 0.15) 0px 1px 2px",
                }}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    ),
    { duration: Infinity }
  );
}